<template>
	<div class="tl-task-list-row">
		<div class="tl-task-list-row-inner" v-bind:style="styleInner">
			<div class="tl-task-list-row-time">
				<div class="tl-task-list-row-time-content">{{ taskTerm.begin_time }}</div>
				<div class="tl-task-list-row-time-content">{{ taskTerm.end_time }}</div>
				<div class="tl-task-list-row-time-content">{{ taskTerm.days }}</div>
			</div>
			<div class="tl-task-list-row-content" v-bind:style="styleContent">
				<div class="name">{{ nameTask }}</div>
				<div class="remarks">{{ remarksTask }}</div>
				<div class="blue--text member" v-if="!isDisplayMemberList">{{ nameMember }}</div>
				<div class="blue--text project" v-else>{{ nameProject }}</div>
			</div>
			<div class="tl-task-list-row-item-showproject" v-if="isDisplayMemberList && hasProject">
				<v-btn fab flat v-on:click="onClickShowProjectTaskList">
					<v-icon>assignment</v-icon>
				</v-btn>
			</div>
			<div class="tl-task-list-row-item-action" v-if="showSlideBtn">
				<v-btn fab flat class="btn-slide" v-on:click.stop="toggleSlideLeft">
					<v-icon>more_horiz</v-icon>
				</v-btn>
			</div>
			<div class="tl-task-list-row-item d-flex" v-if="showSlideBtn">
				<template>
					<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowRightPane">編集</v-btn>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import { SLIDE, DISPLAY_LIST_TYPE, FORM_MODE } from '../../classes/Const';
import ScheduleTick from '../../classes/ScheduleTick';

export default {
	name: 'TLTaskListRow',
	props: [
		"items",
		"schedule",
		"selected_member_code",
		"watchSlide",
	],
	data () {
		return {
			slide_status: SLIDE.STATUS.CENTER,
		}
	},
	methods: {
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('schedule-list-row-slide', {target: this.schedule, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		onShowRightPane: function() {
			this.toggleSlideLeft();
			
			let task = this.$store.getters.task(this.schedule.task_code);
			this.$emit("show-task-info", {
				task: task,
				mode: FORM_MODE.EDIT,
				display_type: this.$store.getters['list/isDisplayMemberList'] ? DISPLAY_LIST_TYPE.MEMBER : DISPLAY_LIST_TYPE.PROJECT,
			});
		},
		onClickShowProjectTaskList: function() {
			if (!this.schedule.project_code)
				return ;
				
			this.$emit('show-project-task-list', this.schedule.project_code);
			this.$store.dispatch('list/setDisplayListTypeProject');
		},
	},
	computed: {
		taskTerm: function() {
			let current_day = this.$store.getters.currentDate;
			let next_day = new Date(current_day.getTime());
			next_day.setDate(next_day.getDate() + 1);
			let current_day_tick = ScheduleTick.createTickFromDate(current_day);
		
			let begin_time = '';
			let end_time = '';
			let days = '';
			
			if (this.schedule.all_day) {
				begin_time = '終日';
				end_time = '';
			} else if (this.schedule.begin.isFirstTick(current_day) && this.schedule.end.isFirstTick(next_day)) {
				begin_time = '終日';
				end_time = '';
			} else if(this.schedule.begin.isBeforeDay(current_day)
					&& (this.schedule.end.isAfterDay(current_day) || this.schedule.end.isFirstTick(next_day))) {
	
				begin_time = '終日';
				end_time = '';
			} else {
				if (this.schedule.begin.isBeforeDay(current_day))
					begin_time = '～';
				else
					begin_time = this.schedule.begin.strftimeDCL('%H:%M');
				
				if (this.schedule.end.isAfterDay(current_day))
					end_time = '～';
				else
					end_time = this.schedule.end.strftimeDCL('%H:%M');
			}
			
			let term = this.schedule.scheduleDayTerm();
			if (term > 1) {
				let day_since_begin = Math.floor((current_day_tick.asDateYmd.getTime() - this.schedule.begin.asDateYmd.getTime() + 86400000) / 86400000);
				days = day_since_begin + '/' + term + '日目';
			}
			
			return {
				begin_time: begin_time,
				end_time: end_time,
				days: days,
			};
		},
		nameTask: function() {
			let task = this.items.children.filter(t => t.code === this.schedule.task_code)[0];
			if (!task)
				return '';
			return task.name;
		},
		remarksTask: function() {
			let task = this.items.children.filter(t => t.code === this.schedule.task_code)[0];
			if (!task)
				return '';
			return task.remarks;
		},
		nameMember: function() {
			let member = this.$store.getters['member'](this.schedule.member_code);
			if (!member)
				return '';
			return member.name;
		},
		nameProject: function() {
			let project = this.$store.getters['project'](this.schedule.project_code);
			if (!project)
				return '';
			return '@' + project.name;
		},
		styleContent: function() {
			let task_term_width = 60;
			let btn_more_width = 56;
			let btn_task_width = 56;
			let total_width = task_term_width + btn_more_width;
			if (this.$store.getters['list/isDisplayMemberList'] && this.schedule.project_code)
				total_width += btn_task_width
			return {
				'min-width': this.$store.getters.clientWidth - total_width + 'px',
			};
		},
		styleInner: function() {
			let left = 0;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				left -= 56;
			}

			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		isDisplayMemberList: function() {
			return this.$store.getters['list/isDisplayMemberList'];
		},
		showSlideBtn: function() {
			if (this.selected_member_code === this.$store.getters['loginUser'].code)
				return true;
			
			return false;
		},
		hasProject: function(){
			return this.schedule.project_code !== undefined && this.schedule.project_code;
		}
	},
	watch: {
		watchSlide: function() {
			if (this.watchSlide.type === 'slide' && this.watchSlide.target === this.schedule)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.tl-task-list-row {
		background-color: #fefefe;
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		height: 65px;
		border-bottom: 1px solid #d3d3d3;
		display: flex;
	}
	.tl-task-list-row-inner {
		display: flex;
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.tl-task-list-row-time {
		min-width: 60px;
		text-align: center;
		font-size: 12px;
		padding: 5px 0px;
	}
	.tl-task-list-row-time-content {
		width: 100%;
		height: 18px;
	}
	.tl-task-list-row-content {
		padding: .25em;
		padding-left: 0.5em;
		width: 100%;
	}
	.tl-task-list-row-item-action {
		position: relative;
	}
	.tl-task-list-row-item-action .btn-slide {
		min-width: 36px !important;
	}
	.tl-task-list-row-item-showproject .v-btn{
		min-width: 56px !important;
	}
	.tl-task-list-row-item div {
		width: 16px;
	}
</style>
<style scoped>
	.v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}
	.name, .remarks, .project, .member {
		word-wrap: normal;
		overflow: hidden;
		height: 1.5em;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.project, .member {
		font-size: .75em;
	}
	.remarks {
		font-size: 12px;
	}
</style>
